import React, { Suspense } from 'react';
import { Router, Redirect } from '@reach/router';

import Loader from '@src/components/loader';
import PrivateRoute from '@src/components/private-route';
// Account components
import AccountContentScreen from '@components/account-content-screen';
// Pages
import ResultPage from './pages/result';
import QuizResults from '@features/account/pages/result/components/QuizResults/QuizResults';
import PillLoading from '@features/account/pages/result/components/PillLoading/PillLoading';
// Hooks
import { useGetAccountData } from './hooks/useGetAccountData';

const Routes: React.FC = () => {
  useGetAccountData();

  return (
    <Suspense fallback={<Loader />}>
      <Router>
        <PrivateRoute path="/account/recommendation" component={ResultPage} />
        <PrivateRoute path="/account/result/dna" component={AccountContentScreen} />
        <PrivateRoute path="/account/result/blood" component={AccountContentScreen} />
        <PrivateRoute path="/account/result/loading" component={PillLoading} />
        <PrivateRoute path="/account/result/strengths" component={QuizResults} />
        <PrivateRoute path="/account/result/goals" component={QuizResults} />
        <PrivateRoute path="/account/result/recommendation_preview" component={QuizResults} />
        <Redirect from="/account/result" to="/account/result/loading" noThrow />
        <Redirect from="/account/result/" to="/account/result/loading" noThrow />
        <PrivateRoute default component={AccountContentScreen} />
        <Redirect from="/account" to="/account/result/loading" noThrow />
      </Router>
    </Suspense>
  );
};

export default Routes;
